import { render, staticRenderFns } from "./invoice_revoke.vue?vue&type=template&id=32db61f4&scoped=true&"
import script from "./invoice_revoke.vue?vue&type=script&lang=js&"
export * from "./invoice_revoke.vue?vue&type=script&lang=js&"
import style0 from "./invoice_revoke.vue?vue&type=style&index=0&id=32db61f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32db61f4",
  null
  
)

export default component.exports